import slice from "./accessTokens.slices";

export const selectSlice = state => state[slice.name];

export const selectAccessToken = state => selectSlice(state).accessToken;
